var miMinHeight = function(){
  //console.log('call minheight')
  var bodyHeight = window.innerHeight;
  console.log('bodyHeight:'+bodyHeight);
  var headerHeight = document.querySelector('.section-header').offsetHeight;
  var footerHeight = document.getElementById('shopify-section-footer').offsetHeight;
  console.log('headerHeight:'+headerHeight);
  console.log('footerHeight:'+footerHeight);
  var contentHeight = bodyHeight-headerHeight-footerHeight;
  document.getElementById('MainContent').style.minHeight = '';
  var mainHeight = document.getElementById('MainContent').offsetHeight;
  console.log('min-height:'+contentHeight);
  console.log('main-height:'+mainHeight);
  if(mainHeight<contentHeight){
    document.getElementById('MainContent').style.minHeight= contentHeight + 'px';
  }
}

document.addEventListener("DOMContentLoaded", function() {
  //run the function if the 'matchage' class is used on the page
   miMinHeight();
});
var toggleFoldOut = function(event){
  event.preventDefault();
  console.log('call fold out');  
  document.body.classList.toggle('overflow-hidden');
  document.querySelector('.product__info-wrapper').classList.toggle("open");  
}
if(document.querySelector(".fold-out-btn")){
  document.querySelector(".fold-out-btn").addEventListener("click", toggleFoldOut);
}
function isValidCode(code) {
  // Check if code exists and is not empty
  if (!code || code.trim().length === 0) {
    return false;
  }
  
  // Optional: Check minimum length (e.g., at least 3 characters)
  if (code.trim().length < 10) {
    return false;
  }
  
  return true;
}